const labels = {
  title: 'Oops... Let’s try that again!',
  text: 'Looks like your request couldn’t be completed. Please try again.',
  gotItButton: 'Got it',
}

export default labels
